import React from "react";
import { Link } from "react-router-dom";
import { FiStar, FiBook, FiAward, FiGlobe, FiTrendingUp } from "react-icons/fi";
import reviewimg from '../Images/reviewimg.png'; // Assuming this image exists from previous context

const ExploreMenu = ({ onClose }) => {
    const menuItems = [
        {
            title: "Top Universities & Colleges",
            icon: <FiStar className="text-yellow-500" />,
            links: [
                { label: "Top Engineering Colleges", to: "/TopUniversitiesandCollegesTag_Engineering" },
                { label: "Top MBA Colleges", to: "/TopUniversitiesandCollegesTag_MBA" },
                { label: "Top Medical Colleges", to: "/TopUniversitiesandCollegesTag_Medical" },
                { label: "College Ranking 2025", to: "/College-Ranking" },
            ]
        },
        {
            title: "Study Abroad",
            icon: <FiGlobe className="text-blue-500" />,
            links: [
                { label: "Colleges in USA", to: "/Study-abroad/USA" },
                { label: "Colleges in UK", to: "/Study-abroad/UK" },
                { label: "Colleges in Canada", to: "/Study-abroad/Canada" },
                { label: "Study Abroad Exams", to: "/Exam" },
            ]
        },
        {
            title: "Exams & Admissions",
            icon: <FiBook className="text-green-500" />,
            links: [
                { label: "Exam Calendar 2025", to: "/Exam" },
                { label: "Admission Alerts", to: "/Admissionalert" },
                { label: "Scholarships", to: "/Scholarship" },
                { label: "College Predictor", to: "/college-predictor" },
            ]
        },
    ];

    return (
        <div className="absolute top-14 right-0 w-[900px] bg-white rounded-lg shadow-2xl z-50 border border-gray-100 animate-fadeIn overflow-hidden flex">
            {/* Left Links Section */}
            <div className="w-2/3 p-6 grid grid-cols-2 gap-8">
                {menuItems.map((section, idx) => (
                    <div key={idx}>
                        <h4 className="flex items-center gap-2 text-sm font-bold text-gray-800 mb-3 border-b border-gray-100 pb-2">
                            {section.icon}
                            {section.title}
                        </h4>
                        <ul className="space-y-2">
                            {section.links.map((link, lIdx) => (
                                <li key={lIdx}>
                                    <Link
                                        to={link.to}
                                        onClick={onClose}
                                        className="text-xs font-medium text-gray-600 hover:text-orange-500 hover:translate-x-1 transition-all inline-block"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}

                {/* Extra Quick Links */}
                <div>
                    <h4 className="flex items-center gap-2 text-sm font-bold text-gray-800 mb-3 border-b border-gray-100 pb-2">
                        <FiTrendingUp className="text-purple-500" />
                        Trending
                    </h4>
                    <ul className="space-y-2">
                        <li><Link to="/programs" onClick={onClose} className="text-xs font-medium text-gray-600 hover:text-orange-500">Popular Courses</Link></li>
                        <li><Link to="/compare" onClick={onClose} className="text-xs font-medium text-gray-600 hover:text-orange-500">Compare Colleges</Link></li>
                        <li><Link to="/review" onClick={onClose} className="text-xs font-medium text-gray-600 hover:text-orange-500">Write a Review</Link></li>
                    </ul>
                </div>
            </div>

            {/* Right Promotional Section */}
            <div className="w-1/3 bg-orange-50 p-6 flex flex-col justify-center items-center text-center border-l border-orange-100">
                <h3 className="text-lg font-bold text-gray-800 mb-2">"Write a Review & <br /> Earn Upto ₹500*"</h3>
                <p className="text-[10px] text-gray-500 mb-4">*Approval in 15 Min</p>

                <div className="flex gap-1 text-orange-400 mb-4">
                    <FiStar fill="currentColor" />
                    <FiStar fill="currentColor" />
                    <FiStar fill="currentColor" />
                    <FiStar fill="currentColor" />
                    <FiStar fill="currentColor" />
                </div>

                {/* Placeholder Illustration */}
                <div className="mb-4 opacity-80">
                    <img src={reviewimg} alt="Write Review" className="w-24 h-auto mx-auto mix-blend-multiply" />
                </div>

                <Link
                    to="/review"
                    onClick={onClose}
                    className="bg-orange-500 text-white text-xs font-bold px-6 py-2 rounded-full hover:bg-orange-600 transition shadow-lg hover:shadow-orange-500/30"
                >
                    Write Review Now
                </Link>
            </div>
        </div>
    );
};

export default ExploreMenu;
